import { request } from '../request'

const blackFriday = {
    // 获取黑5活动页面数据
    getData: data => request('/api/activity/get_activity_time', 'get', data),
}
export default blackFriday

